import { useMemo } from "react";

import { useTranslation } from "utils";

/** The one place forecast years are labelled: the short form in dense year columns, the long form in headers and tooltips. */
export const useYearLabel = () => {
  const { t } = useTranslation("scenarioAnalysis");
  return useMemo(
    () => ({
      formatYearShort: (year: number): string => t("outcomeComparison.column.yearShort", { year: String(year) }),
      formatYear: (year: number): string => t("outcomeComparison.column.year", { year: String(year) }),
    }),
    [t]
  );
};
